import type { DynamicAdditionalGroupsConfig } from '../../../types';
import { DynamicInputConfigType } from '../../../types';

export class DynamicFormAdditionalGroups {
  public readonly kind = <const>'DynamicFormAdditionalGroups';
  public type: DynamicAdditionalGroupsConfig['type'] = DynamicInputConfigType.ADDITIONAL_GROUPS;

  constructor(public config: DynamicAdditionalGroupsConfig) {}
}
